


  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block">

        <div class="row p-5 d-flex justify-content-center">
          <div class="form-group col-4">
            <label>Menu Name</label>
            <input type="text" class="form-control" id="menuName" placeholder="MenuName">
          </div>

          <div class="form-group col-4 ">
            <label>Menu Url</label>
            <input type="text" class="form-control" id="menuUrl" placeholder="MenuUrl">
          </div>
          <div class="col-4 text-center">
            <!--<button class="btn btn-cancel" id="delete" ngbTooltip="Delete"
                    placement="bottom" type="submit"><i class="fa fa-trash-o"
                                                        style="color:#ee7125"></i>-->
            <button class="btn btn-outline-primary" style="position:relative;margin-top:29px;"> save
            </button>
          </div>
          </div>

      </div>

    </div>
  </div>
